import { PromptTemplateCategory } from '../types';

export const professional: PromptTemplateCategory = {
  title: "Professionnel",
  icon: "💼",
  templates: [
    {
      title: "Script YouTube / Vidéo",
      content: `Écrivez un script pour une vidéo YouTube narrée par une seule personne.
- Le sujet de la vidéo est [5 erreurs courantes en télétravail — et comment les corriger].
- Public cible : [jeunes professionnels débutant leur premier emploi à distance].
- Ton : [amical, conversationnel et pratique — comme les conseils d'un collègue de confiance].
- Structurez avec une accroche forte dans les deux premières phrases, des transitions claires entre les points et une conclusion brève avec un appel à l'action.
- Écrivez pour l'oral : utilisez des paragraphes courts et des questions rhétoriques pour maintenir l'attention de l'auditeur.`
    },
    {
      title: "Explication de Produit",
      content: `Écrivez un script de voix off pour une vidéo explicative de produit.
- Le produit est [une application mobile qui aide les petits entrepreneurs à suivre leurs dépenses en scannant les reçus].
- Public cible : [freelances et petits entrepreneurs qui détestent la comptabilité].
- Avantages clés à mettre en avant :
  1. [Scannez un reçu en 2 secondes — pas de saisie manuelle].
  2. [Catégories de dépenses automatiques avec suggestions intelligentes].
  3. [Export en un clic pour la période fiscale].
- Ton : [clair, dynamique et rassurant — cela rend une tâche pénible facile].
- Gardez des phrases concises et percutantes. Évitez le jargon.`
    },
    {
      title: "Discours de Présentation",
      content: `Écrivez un discours pour une présentation professionnelle ou une conférence.
- L'occasion est [une réunion générale d'entreprise pour lancer un nouveau trimestre].
- L'orateur est [un responsable d'équipe s'adressant à un public mixte d'ingénieurs, designers et managers].
- Message central : [célébrer les succès du trimestre passé, reconnaître honnêtement les défis et mobiliser l'équipe autour d'un objectif clair pour les mois à venir].
- Ton : [confiant, sincère et motivant — pas de langue de bois].
- Durée parlée approximative : [4 minutes].
- Utilisez des formulations conversationnelles, des pauses stratégiques et une phrase finale mémorable.`
    }
  ]
};
